import React, { useState, useEffect } from "react";

import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import config from "../../../config/config";
import Select from "react-select";
import moment from "moment";
import { toastError, toastSuccess } from "../../../../src/common/Toast";
import {
  DATA_EXPORT,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../../src/common/Constant";
import Loader from "../../../components/Loader/Loader";
import SplittingConfirmationModal from "../../../components/Modal/SplittingModal";

const ViewRegister = () => {
  const paramObject = useParams();
  const navigate = useNavigate();

  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  //const loginuserid = localStorage.getItem("ID");
  const [amount, setAmount] = useState(0);
  const [chartOfAccountDropdown, setChartOfAccountDropdown] = useState([]);
  const [transactionTypeDropdown, setTransactionTypeDropdown] = useState([]);
  const [appointmentForPerson, setAppointmentForPerson] = useState([]);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [fromQuickbookId, setfromQuickbookId] = useState(0);
  const [toquickbookid, settoquickbookid] = useState(0);
  const [payeequickbookid, setpayeequickbookid] = useState(0);
  const [billquickbookid, setbillquickbookid] = useState(0);
  // const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [accountValue, setAccountValue] = useState();
  const [showRow, setShowRow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectTransaction, setSelectTransaction] = useState(1);
  const [selectRecouncile, setSelectRecouncile] = useState(1);
  const [amountforAPandAR, setAmountforAPandAR] = useState(0);
  const loginuserid = localStorage.getItem("ID");

  const [beginningDate, setBeginningDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [finalDate, setFinalDate] = useState(moment().format("YYYY-MM-DD"));
  const [customeDate, setCustomDate] = useState();
  const [accountId, setAccountId] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [supplierId, setSupplierId] = useState(0);
  const [customerId, setCustomerId] = useState(0);
  const [employeeId, setEmployeeId] = useState(0);
  const [stateModal, setStateModal] = useState({ visible: null });
  const [transactiontype, setTransactionType] = useState(0);
  const [id, setID] = useState(0);
  const [viewregasterQuickbookIds, setviewregasterQuickbookIds] = useState(0);
  const [notlistingdata, setnotlistingdata] = useState([]);
  const [Transferquickbookid, setTransferquickbookid] = useState(0);
  const [Deposit, setDeposit] = useState(0);
  const [Payment, setPayment] = useState(0);
  const [newPayeeDropdown, setNewPayeeDropdown] = useState([]);
  const [rowsData, setRowsData] = useState([{ cr: "" }]);
  const [newRowData, setNewRowData] = useState([
    {
      Date: moment().format("YYYY-MM-DD"),
      cr: "",
      Memo: "",
    },
  ]);
  const [splits, setSplits] = useState([]);
  const [dropdown, setDropdown] = useState(false);
  const [pendinginvoice, setPendingInvoice] = useState([]);
  const [payee, setPayee] = useState(false);
  const [type, setType] = useState(false);
  const [payeeid, setPayeeId] = useState(0);
  const [transactionid, setTransactionId] = useState(0);
  const [payeeusertype, setPayeeUserType] = useState("");
  const [selectedinvoice, setSelectedInvoice] = useState("");
  const [currentOrder, setCurrentOrder] = useState(""); // column name
  const [orderColumn, setOrderColumn] = useState(""); // asc, desc

  //Toggle the CR
  const [toggleIndex, setToggleIndex] = useState(0);
  const [toggleRowIndex, setToggleRowIndex] = useState(0);
  const [paymentamount, setPaymentAmount] = useState("");
  const [labelinvoice, setLabelInvoice] = useState([]);
  const [moduledelete, setModuleDelete] = useState("");

  const [viewRegisterData, setViewRegisterData] = useState([]);
  const [showSortData, setShowSortData] = useState(false);
  const [TransactionTypeID, setTransactionTypeID] = useState(1);

  console.log(orderColumn, currentOrder, "orderColumnorderColumn");
  console.log(selectTransaction, "selectTransaction");

  // const accountType = [
  //   { label: 'Check', value: 1 },
  //   { label: 'Deposit', value: 2 },
  //   { label: 'Sale Receipt', value: 3 },
  //   { label: 'Receive Payment', value: 4 },
  //   { label: 'Bill Payment', value: 5 },
  //   { label: 'Refund', value: 6 },
  //   { label: 'Expense', value: 7 },
  //   { label: 'Transfer', value: 8 },
  //   { label: 'Journal Entry', value: 9 },
  // ]

  // const recouncileStatusOption = [
  //   { label: "All", value: 1 },
  //   { label: "Reconciled", value: 2 },
  //   { label: "Clear", value: 3 },
  //   { label: "No Status", value: 4 },
  //   { label: "Not Reconciled", value: 5 },
  // ]

  const dateOptions = [
    { label: "Today", value: 1 },
    { label: "This Week", value: 4 },
    { label: "This Month", value: 3 },
    { label: "Last Month", value: 6 },
    { label: "This Year", value: 5 },
    { label: "Last Year", value: 2 },
    { label: "Custom", value: 7 },
  ];

  const rowsInput = {
    ID: 0,
    Account: "",
    AccountID: 0,
    Balance: 0,
    Date: "",
    Deposit: 0,
    Memo: "",
    Module: "",
    Payee: "",
    PayeeId: 0,
    PayeeUserType: "",
    Payment: 0,
    RefNo: "",
    RowNumber: 0,
    TransactionTypeID: 0,
    Type: "",
    cr: "",
    balance: 0,
    showDelete: false,
  };

  // const addTableRows = (rowsInput) => {
  //   setRowsData([rowsInput].concat(rowsData));
  //   setShowRow(true)
  // }
  // console.log(rowsData?.length, "rowsData114");
  console.log(rowsData, "rowsData114");

  // Styles
  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     "&:hover": {
  //       backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
  //     },
  //   }),
  // };

  const newTableCommonClass = {
    padding: "0px",
    backgroundColor: "rgb(237, 237, 237)",
    fontSize: "12px",
    paddingRight: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };

  const selectDropdownStyles = {
    control: (provided, state) => ({
      ...provided,
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc",
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
  };

  const selectStyles = {
    // dropdown input css
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      color: "#000",
      width: "100%",
    }),
    // dropdown option css
    option: (provided, state) => ({
      ...provided,
      color: state.isActive ? "#000" : "#000",
      backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
      "&:hover": {
        color: "#000",
        backgroundColor: "rgba(255, 159, 67, 0.8)", // change hover color to light orange
      },
    }),
  };

  //TransactionType Dropdown

  let transactionTypeDropdownOption = [];

  const transactionDropdown = transactionTypeDropdown?.map((u, i) => {
    transactionTypeDropdownOption[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  const newTransactionTypeDropdownOption = transactionTypeDropdownOption.filter(
    (el) => el.value != 3 && el.value != 8 && el.value != 9
  );

  console.log(transactionTypeDropdownOption, "transactionTypeDropdownOption");
  console.log(
    newTransactionTypeDropdownOption,
    "newTransactionTypeDropdownOption"
  );

  // console.log(transactionTypeDropdownOption, "transactionTypeDropdownOption")
  // Account Type Dropdown
  let accountTypeDropdownOption = [];

  const AccountDropdown = chartOfAccountDropdown?.map((u, i) => {
    accountTypeDropdownOption[i] = {
      label: u.Name,
      value: u.ID,
      amount: u.Amount,
      QuickbookId: u.QuickbookId,
    };
  });
  // console.log("AccountDropdown 159", accountTypeDropdownOption);

  //Payee customer and Supplier
  let appointmentPersonOptions = [];
  let UserType = [];
  const Person = appointmentForPerson.map((u, i) => {
    if (u.IsCustomer == 1) {
      UserType = "Customer";
    } else if (u.IsCustomer == 0) {
      UserType = "Supplier";
    } else {
      UserType = "Employee";
    }
    appointmentPersonOptions[i] = {
      label: u.FirstName + " " + `(${UserType})`,
      value: u.Id,
      QuickBookId: u.QuickBookId,
      IsCustomer: u.IsCustomer,
      UserType: UserType,
    };
  });

  console.log(
    appointmentPersonOptions?.filter((el) => el?.UserType === "Employee"),
    "Employee 45610"
  );
  console.log(
    appointmentPersonOptions?.filter((el) => el?.UserType === "Supplier"),
    "Supplier 45610"
  );
  console.log(
    appointmentPersonOptions?.filter((el) => el?.UserType === "Customer"),
    "Customer 45610"
  );

  const handelSortByAscDesc = (event) => {
    const columnName = event?.target?.id;
    setShowSortData(true);
    console.log(columnName, "column name of click on tag");

    const sortOrder = orderColumn === "desc" ? "asc" : "desc";
    console.log("in function 145 rowsData before call");

    if (columnName === "Payment") {
      if (sortOrder === "asc") {
        setViewRegisterData(
          rowsData
            .slice()
            .sort((a, b) => parseFloat(a.Payment) - parseFloat(b.Payment))
        );
      } else {
        setViewRegisterData(
          rowsData
            .slice()
            .sort((a, b) => parseFloat(b.Payment) - parseFloat(a.Payment))
        );
      }
    } else if (columnName === "Balance") {
      if (sortOrder === "asc") {
        setViewRegisterData(
          rowsData
            .slice()
            .sort((a, b) => parseFloat(a.Balance) - parseFloat(b.Balance))
        );
      } else {
        setViewRegisterData(
          rowsData
            .slice()
            .sort((a, b) => parseFloat(b.Balance) - parseFloat(a.Balance))
        );
      }
    } else if (columnName === "Deposit") {
      if (sortOrder === "asc") {
        setViewRegisterData(
          rowsData
            .slice()
            .sort((a, b) => parseFloat(a.Deposit) - parseFloat(b.Deposit))
        );
      } else {
        setViewRegisterData(
          rowsData
            .slice()
            .sort((a, b) => parseFloat(b.Deposit) - parseFloat(a.Deposit))
        );
      }
    } else if (columnName === "Memo") {
      if (sortOrder === "asc") {
        setViewRegisterData(
          rowsData.slice().sort((a, b) => {
            const memoA = a.Memo || ""; // Handle cases where Memo is null or undefined
            const memoB = b.Memo || "";

            return memoA.localeCompare(memoB);
          })
        );
      } else {
        setViewRegisterData(
          rowsData.slice().sort((a, b) => {
            const memoA = a.Memo || ""; // Handle cases where Memo is null or undefined
            const memoB = b.Memo || "";

            return memoB.localeCompare(memoA);
          })
        );
      }
    } else if (columnName === "Payee") {
      if (sortOrder === "asc") {
        setViewRegisterData(
          rowsData.slice().sort((a, b) => {
            const payeeA = a.Payee || ""; // Handle cases where Memo is null or undefined
            const payeeB = b.Payee || "";

            return payeeA.localeCompare(payeeB);
          })
        );
      } else {
        setViewRegisterData(
          rowsData.slice().sort((a, b) => {
            const payeeA = a.Payee || ""; // Handle cases where Memo is null or undefined
            const payeeB = b.Payee || "";

            return payeeB.localeCompare(payeeA);
          })
        );
      }
    } else if (columnName === "AccountID") {
      sortOrder === "asc"
        ? setViewRegisterData(
            rowsData.slice().sort((a, b) => a.AccountID - b.AccountID)
          )
        : setViewRegisterData(
            rowsData.slice().sort((a, b) => b.AccountID - a.AccountID)
          );
    } else if (columnName === "Type") {
      sortOrder === "asc"
        ? setViewRegisterData(
            rowsData.slice().sort((a, b) => a.Type.localeCompare(b.Type))
          )
        : setViewRegisterData(
            rowsData.slice().sort((a, b) => b.Type.localeCompare(a.Type))
          );
    } else if (columnName === "Date") {
      sortOrder === "asc"
        ? setViewRegisterData(
            rowsData.slice().sort((a, b) => new Date(a.Date) - new Date(b.Date))
          )
        : setViewRegisterData(
            rowsData.slice().sort((a, b) => new Date(b.Date) - new Date(a.Date))
          );
    } else if (columnName === "RefNo") {
      sortOrder === "asc"
        ? setViewRegisterData(
            rowsData
              .slice()
              .sort((a, b) => (a.RefNo || "").localeCompare(b.RefNo || ""))
          )
        : setViewRegisterData(
            rowsData
              .slice()
              .sort((a, b) => (b.RefNo || "").localeCompare(a.RefNo || ""))
          );
    }

    console.log("column not matched");
    setOrderColumn(sortOrder);
    // setRowsData(sortedArray);
  };

  // console.log(appointmentPersonOptions, "appointmentPersonOptions 121");

  // const handleName = (index, event) => {
  //   console.log("event", event);
  //   let evnt = {
  //     target: {
  //       name: "userid",
  //       value: event.value,
  //       IsCustomer: event.IsCustomer,
  //     },
  //   };
  // };

  console.log(viewRegisterData, "viewRegisterData");

  const handlePayeeType = (event) => {
    // console.log("event242", event,);

    if (event?.IsCustomer == 1) {
      // customer
      setSupplierId(0);
      setEmployeeId(0);
      setCustomerId(event?.value);
    } else if (event?.IsCustomer == 2) {
      // employeee
      setSupplierId(0);
      setCustomerId(0);
      setEmployeeId(event?.value);
    } else {
      // supplier
      setSupplierId(event?.value);
      setCustomerId(0);
      setEmployeeId(0);
    }
  };

  const selectTransactionHandle = (e) => {
    setSelectTransaction(e);
  };

  // console.log(selectTransaction, "selectTransaction")

  //New Input field

  const fetchdata = (
    transactionid,
    payeeid,
    payeeusertype,
    locationid,
    startdate,
    enddate
  ) => {
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/viewregisterpendinginvoiceandbills?transactiontypeid=${transactionid}&payeeid=${payeeid}&payeeusertype=${payeeusertype}&locationid=${locationid}&startdate=${startdate}&enddate=${enddate}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("invoicedata", res.data.ResponseData[0].QuickBookId);
        setPendingInvoice(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  let invoicedatadropdown = [];
  const datadropdown = pendinginvoice?.map((u, i) => {
    invoicedatadropdown[i] = {
      label: u.Name,
      value: u.ID,
      total: u.PaymentBalance,
      QuickBookId: u.QuickBookId,
    };
  });

  console.log(newRowData, "newRowData");
  const handleNewInputChange = (event, fieldName) => {
    console.log(event, fieldName, "186");
    if (fieldName === "Type") {
      let updatedData = [...newRowData];
      updatedData[0] = {
        ...updatedData[0],
        [fieldName]: event?.value,
      };
      setDropdown(false);
      setNewRowData(updatedData);
      setTransactionId(event?.value);

      if (event?.value == 7 || event?.value == 11) {
        if (payee) {
          fetchdata(
            event?.value,
            payeeid,
            payeeusertype,
            locationid,
            beginningDate,
            finalDate
          );
        }
        setDropdown(true);
        setType(true);
      }
    } else if (fieldName === "Date") {
      const updatedData = [...newRowData];
      updatedData[0] = {
        ...updatedData[0],
        [fieldName]: event?.target?.value,
      };
      setNewRowData(updatedData);
    } else if (fieldName === "RefNo") {
      const updatedData = [...newRowData];
      updatedData[0] = {
        ...updatedData[0],
        [fieldName]: event,
      };
      setNewRowData(updatedData);
    } else if (fieldName === "PayeeId") {
      console.log(event, "event=====>");
      const updatedData = [...newRowData];
      updatedData[0] = {
        ...updatedData[0],
        [fieldName]: event?.value,
        ["Payee"]: event?.label,
        // ["PayeeUserType"]: event?.IsCustomer == 1 ? "Customer" : "Supplier",
        ["PayeeUserType"]:
          event?.IsCustomer == 1
            ? "Customer"
            : event?.IsCustomer == 0
            ? "Supplier"
            : "Employee",
      };
      setNewRowData(updatedData);
      setPayee(true);
      setPayeeId(event?.value);
      setpayeequickbookid(event?.QuickBookId);
      // setPayeeUserType(event?.IsCustomer == 1 ? "Customer" : "Supplier");
      setPayeeUserType(
        event?.IsCustomer == 1
          ? "Customer"
          : event?.IsCustomer == 0
          ? "Supplier"
          : "Employee"
      );

      if ((type && transactionid == 7) || transactionid == 11) {
        fetchdata(
          transactionid,
          event?.value,
          // event?.IsCustomer == 1 ? "Customer" : "Supplier",
          event?.IsCustomer == 1
            ? "Customer"
            : event?.IsCustomer == 0
            ? "Supplier"
            : "Employee",
          locationid,
          beginningDate,
          finalDate
        );
      }
    } else if (fieldName === "AccountID") {
      console.log(event, "event====>");
      const updatedData = [...newRowData];
      updatedData[0] = {
        ...updatedData[0],
        // [fieldName]: event,
        [fieldName]: event?.value,
        ["QuickbookId"]: event?.QuickbookId,
      };
      settoquickbookid(event?.QuickbookId);
      setNewRowData(updatedData);
    } else if (fieldName === "Memo") {
      const updatedData = [...newRowData];
      updatedData[0] = {
        ...updatedData[0],
        [fieldName]: event?.target?.value,
      };
      setNewRowData(updatedData);
    }
    if (fieldName === "Payment" || fieldName === "Deposit") {
      const updatedData = [...newRowData];
      updatedData[0] = {
        ...updatedData[0],
        [fieldName]: event?.target?.value,
      };

      // Check if one field has a value and the other doesn't, then update accordingly
      if (fieldName === "Payment") {
        updatedData[0]["Deposit"] = 0;
      } else if (fieldName === "Deposit") {
        updatedData[0]["Payment"] = 0;
      }
      setNewRowData(updatedData);
    }
    if (fieldName === "BillInvoice") {
      console.log(event?.QuickBookId, "events==>");

      let event1 = event ? [event] : [];

      setLabelInvoice(event1);
      setbillquickbookid(event?.QuickBookId);

      const value = event1?.reduce((acc, curr) => {
        acc = acc + Number(curr.total);
        return acc;
      }, 0);
      // const value=0

      // setPaymentAmount(value);
      console.log(event1, "event1ss==>");
      const updatedData = [...newRowData];

      if (updatedData[0]["Type"] == 7) {
        updatedData[0]["Deposit"] = 0;
        updatedData[0]["Payment"] = value;
      } else if (updatedData[0]["Type"] == 11) {
        updatedData[0]["Payment"] = 0;
        updatedData[0]["Deposit"] = value;
      }

      updatedData[0] = {
        ...updatedData[0],
        [fieldName]: event1.map((el) => el.value).join(","),
      };

      setSelectedInvoice(event1.map((el) => el.value).join(","));
      setNewRowData(updatedData);
    }

    // else if (fieldName === "cr") {
    //   const updatedData = [...newRowData];
    //   updatedData[0] = {
    //     ...updatedData[0],
    //     [fieldName]: event?.target?.value,
    //   };
    //   setNewRowData(updatedData);
    // }
  };

  console.log(newRowData, "newrowdata");

  // Toggle button for CR
  const handleInputClick = () => {
    const updatedData = [...newRowData];
    const currentIndex = toggleIndex % 3;

    if (currentIndex === 0) {
      updatedData[0] = {
        ...updatedData[0],
        cr: "C",
      };
    } else if (currentIndex === 1) {
      updatedData[0] = {
        ...updatedData[0],
        cr: "R",
      };
    } else {
      updatedData[0] = {
        ...updatedData[0],
        cr: "",
      };
    }
    setToggleIndex(currentIndex + 1);
    setNewRowData(updatedData);
  };

  console.log(transactionid, "transactionid");
  console.log(newRowData, newRowData);
  //Input for the fields

  const handleInputChange = (event, index, fieldName) => {
    // console.log(event, index, fieldName, "131")

    if (fieldName === "Type") {
      const updatedData = [...rowsData];
      updatedData[index] = {
        ...updatedData[index],
        [fieldName]: event,
      };
      setRowsData(updatedData);
    } else if (fieldName === "Date") {
      const updatedData = [...rowsData];
      updatedData[index] = {
        ...updatedData[index],
        [fieldName]: event?.target?.value,
      };
      setRowsData(updatedData);
    } else if (fieldName === "RefNo") {
      const updatedData = [...rowsData];
      updatedData[index] = {
        ...updatedData[index],
        [fieldName]: event,
      };
      setRowsData(updatedData);
    } else if (fieldName === "PayeeId") {
      const updatedData = [...rowsData];
      updatedData[index] = {
        ...updatedData[index],
        [fieldName]: event?.value,
        ["Payee"]: event?.label,
        ["PayeeUserType"]:
          event?.IsCustomer == 1
            ? "Customer"
            : event?.IsCustomer == 0
            ? "Supplier"
            : "Employee",
      };
      setRowsData(updatedData);
    } else if (fieldName === "AccountID") {
      const updatedData = [...rowsData];
      updatedData[index] = {
        ...updatedData[index],
        // [fieldName]: event,
        [fieldName]: event?.value,
      };
      setRowsData(updatedData);
    } else if (fieldName === "Memo") {
      const updatedData = [...rowsData];
      updatedData[index] = {
        ...updatedData[index],
        [fieldName]: event?.target?.value,
      };
      setRowsData(updatedData);
    }
    if (fieldName === "Payment" || fieldName === "Deposit") {
      const updatedData = [...rowsData];
      updatedData[index] = {
        ...updatedData[index],
        [fieldName]: event?.target?.value,
      };

      // Check if one field has a value and the other doesn't, then update accordingly
      if (fieldName === "Payment" && updatedData[index]["Deposit"]) {
        updatedData[index]["Deposit"] = 0;
      } else if (fieldName === "Deposit" && updatedData[index]["Payment"]) {
        updatedData[index]["Payment"] = 0;
      }

      setRowsData(updatedData);
    }
    // else if (fieldName === "cr") {
    //   const updatedData = [...rowsData];
    //   updatedData[index] = {
    //     ...updatedData[index],
    //     [fieldName]: event?.target?.value,
    //   };
    //   setRowsData(updatedData);
    // }
  };

  //Toggle button for the Cr when data is coming from the backend

  const handleRowInputClick = (index) => {
    const updatedData = [...rowsData];
    const currentIndex = toggleRowIndex % 3;

    if (currentIndex === 0) {
      updatedData[index] = {
        ...updatedData[index],
        cr: "C",
      };
    } else if (currentIndex === 1) {
      updatedData[index] = {
        ...updatedData[index],
        cr: "R",
      };
    } else {
      updatedData[index] = {
        ...updatedData[index],
        cr: "",
      };
    }

    setToggleRowIndex(currentIndex + 1);
    setRowsData(updatedData);
  };

  console.log(newRowData, "newRowData");

  //removing the newly Added row

  const handleRemove = () => {
    setShowRow(false);
    setPaymentAmount("");
    setNewRowData([{ Date: moment().format("YYYY-MM-DD") }]);
    setLabelInvoice([]);
  };

  //Date

  //Today
  let today = moment().format("YYYY-MM-DD");
  //Week
  const startOfWeek = moment().startOf("week").format("YYYY-MM-DD");
  const endOfWeek = moment().endOf("week").format("YYYY-MM-DD");
  //This Month
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  //Last Month
  const startOfLastMonth = moment()
    .subtract(1, "month")
    .startOf("month")
    .format("YYYY-MM-DD");
  const endOfLastMonth = moment()
    .subtract(1, "month")
    .endOf("month")
    .format("YYYY-MM-DD");
  //This Year
  const startOfYear = moment().startOf("year").format("YYYY-MM-DD");
  const endOfYear = moment().endOf("year").format("YYYY-MM-DD");
  //Last Year
  const startOfLastYear = moment()
    .subtract(1, "year")
    .startOf("year")
    .format("YYYY-MM-DD");
  const endOfLastYear = moment()
    .subtract(1, "year")
    .endOf("year")
    .format("YYYY-MM-DD");

  const handleDateFilter = (event) => {
    // console.log(event, "eventtt");
    setCustomDate(event?.value);
    if (event?.value == 1) {
      setBeginningDate(today);
      setFinalDate(today);
    } else if (event?.value == 4) {
      setBeginningDate(startOfWeek);
      setFinalDate(endOfWeek);
    } else if (event?.value == 3) {
      setBeginningDate(startOfMonth);
      setFinalDate(endOfMonth);
    } else if (event?.value == 6) {
      setBeginningDate(startOfLastMonth);
      setFinalDate(endOfLastMonth);
    } else if (event?.value == 5) {
      setBeginningDate(startOfYear);
      setFinalDate(endOfYear);
    } else if (event?.value == 2) {
      setBeginningDate(startOfLastYear);
      setFinalDate(endOfLastYear);
    } else if (event?.value == null) {
      setBeginningDate("");
      setFinalDate("");
    }
  };

  const handleViewRegisterAPI = (
    searchtext,
    transactiontype,
    customerid,
    supplierid,
    startdate,
    enddate,
    accountid,
    employeeId
  ) => {
    setRowsData(null);
    setLoading(true);

    // const currentOrder ="desc" //asc
    // const orderColumn ="date" //1

    axios
      .get(
        `${
          config.accountingBaseUrl
        }/chartofaccounts/accountviewregister?searchtext=${searchtext}&transactiontype=${
          transactiontype ? transactiontype : 1
        }&customerid=${customerid ? customerid : 0}&supplierid=${
          supplierid ? supplierid : 0
        }&startdate=${startdate}&enddate=${enddate}&locationid=${locationid}&accountid=${accountid}&employeeid=${
          employeeId ? employeeId : 0
        }`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("response ==>", res.data.ResponseData);
        const newarr = res.data.ResponseData.map((el) => {
          return {
            ...el,
            showDelete: true,
            Payment: parseFloat(el.Payment).toFixed(2),
            Deposit: parseFloat(el.Deposit).toFixed(2),
            showAll: el.Type === "Expense" ? true : false,
          };
        });

        setRowsData(newarr);

        // const highestRowNumber = res.data?.ResponseData.reduce((max, current) => {
        //   return current.RowNumber > max.RowNumber? current : max;
        // }, { RowNumber: 0, Balance: 0 });

        // const highestBalance = highestRowNumber.Balance;
        // const highestRowNumberRecord = res.data?.ResponseData?.reduce((prev, current) =>
        //   prev.RowNumber > current.RowNumber ? prev : current
        // );
        // const balance = highestRowNumberRecord.Balance;

        // console.log(balance, "balance");
        // setAmountforAPandAR(newarr[newarr?.length - 1].Balance);

        if (accountid == 1 || accountid == 5) {
          setAmount(newarr[newarr?.length - 1]?.Balance);
        }

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const AccountAPI = () => {
    // chart of Account Dropdown for account id
    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accountddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        // console.log("ChartOfAccountDropdown", res.data.ResponseData);
        setChartOfAccountDropdown(res.data.ResponseData);

        let filterAccount = res.data.ResponseData.find(
          (option) => option?.ID == paramObject.id //?.value
        );
        /// console.log("filterAccount ===>", filterAccount);
        let filterAccountQuickbookId = res.data.ResponseData.find(
          (option) => option?.ID == paramObject.id //?.value
        );
        console.log(filterAccountQuickbookId, "fromid");

        setfromQuickbookId(filterAccountQuickbookId.QuickbookId);

        setAmount(filterAccount.Amount);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const AccountSaveAPI = () => {
    // chart of Account Dropdown for account id
    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accountddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        // console.log("ChartOfAccountDropdown", res.data.ResponseData);
        setChartOfAccountDropdown(res.data.ResponseData);

        let filterAccount = res.data.ResponseData.find(
          (option) => option?.ID == accountId //?.value
        );

        /// console.log("filterAccount ===>", filterAccount);
        setAmount(filterAccount.Amount);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const payeeAPI = () => {
    //payee Api
    axios
      .get(
        `${config.appointmentBaseUrl}/appointments/appointmentpersonddl/?isCustomer=0`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setAppointmentForPerson(res.data.ResponseData);
        console.log("res ", res.data.ResponseData);
      });
  };

  const transactionType = () => {
    //payee Api
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/getalltransactiontype?isshowviewregister=1`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setTransactionTypeDropdown(res.data.ResponseData);
        // console.log("res280", res.data.ResponseData);
      });
  };

  const handleSubmit = (type, index, issplit) => {
    // console.log(index, "424")
    setLabelInvoice([]);
    setDropdown(false);
    let requestPayload = {};
    if (type == "edit") {
      let selectedRowsData = rowsData[index];
      requestPayload = {
        id: selectedRowsData?.ID > 0 ? selectedRowsData?.ID : 0,
        accountid: accountId,
        transactiontypeid:
          selectedRowsData?.ID > 0
            ? selectedRowsData?.TransactionTypeID
            : selectedRowsData.Type,
        date: selectedRowsData?.Date,
        refno: selectedRowsData?.RefNo,
        payeeid: selectedRowsData?.PayeeId,
        payeeusertype: selectedRowsData?.PayeeUserType,
        accountcategoryid: selectedRowsData?.AccountID,

        memo: selectedRowsData?.Memo,
        payment: selectedRowsData?.Payment,
        deposit: selectedRowsData?.Deposit,
        cr: selectedRowsData?.cr,
        locationid: locationid,
        loginuserid: loginuserid,
        issplit: issplit,
        module: selectedRowsData?.Module,
      };
    } else {
      // console.log(newRowData, "filteredData");

      let selectedRowsData = newRowData[0];

      requestPayload = {
        id: 0,
        accountid: accountId,
        toaccountQuickbookId: fromQuickbookId,
        transactiontypeid: selectedRowsData.Type,
        date: selectedRowsData?.Date,
        refno: selectedRowsData?.RefNo,
        payeeid: selectedRowsData?.PayeeId,
        payeeusertype: selectedRowsData?.PayeeUserType,
        accountcategoryid: selectedRowsData?.AccountID,
        fromaccountquickbookid: toquickbookid,
        memo: selectedRowsData?.Memo,
        payment: selectedRowsData?.Payment,
        // Number(selectedRowsData?.Payment)>=0
        //   ? Number(selectedRowsData?.Payment)
        //   : paymentamount,
        deposit: selectedRowsData?.Deposit,
        // (selectedRowsData?.Deposit)>=0
        // ? (selectedRowsData?.Deposit)
        // : paymentamount,
        // selectedRowsData?.Type == 11
        //   ? paymentamount
        //   : selectedRowsData?.Deposit,
        cr: selectedRowsData?.cr,
        locationid: locationid,
        loginuserid: loginuserid,
        issplit: 0,
        billinvoiceno: selectedinvoice,
        quickbookid: payeequickbookid,
        billsquickbookid: billquickbookid,
      };
    }

    // console.log("requestPayload ==>", requestPayload);

    setLoading(true);
    axios
      .post(
        `${config.accountingBaseUrl}/chartofaccounts/accountviewregisterupsert`,
        // rowsData[index],
        requestPayload,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res data ==========>>>>", res);
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          setShowRow(false);
          handleViewRegisterAPI(
            searchText,
            selectTransaction,
            customerId,
            supplierId,
            beginningDate,
            finalDate,
            accountId,
            employeeId
          );
          AccountSaveAPI();
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
    setNewRowData([{ Date: moment().format("YYYY-MM-DD"), cr: "", Memo: "" }]);
  };

  const handleQuickBookChange = (e, i) => {
    // console.log(e, e?.amount, i, "test amount");

    console.log(e?.value, "change value");

    // if (e?.value === 5 || e?.value === 1) {
    //   setAmount(amountforAPandAR);
    // } else {
    //   setAmount(Number(e?.amount));
    // }

    setAmount(Number(e?.amount));
    setAccountValue(e?.value);
    e?.value != undefined && navigate(`/view-register/${e?.value}`);
  };
  console.log(accountValue, "accountValue");
  console.log(amountforAPandAR, accountValue, "amountforAPandAR");

  //Delete
  const handleDeleteClick = (item, index) => {
    if (item.QuickbookId > 0) {
      if (item.Module === "RECEIVEPAYMENT") {
        setLoading(true);
        axios
          .get(
            `${config.accountingBaseUrl}/chartofaccounts/deletedataviewregister?ID=${item.ID}&Module=RECEIVEPAYMENT`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            //console.log(res.data.ResponseData, "mydear");
            setnotlistingdata(res.data.ResponseData);

            setStateModal({ visible: index });
          })
          .catch((error) => {
            setLoading(false);
          });
      } else if (item.Module === "PAYBILLS") {
        setLoading(true);
        axios
          .get(
            `${config.accountingBaseUrl}/chartofaccounts/deletedataviewregister?ID=${item.ID}&Module=PAYBILLS`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            setLoading(false);
            //console.log(res.data.ResponseData, "mydear");
            setnotlistingdata(res.data.ResponseData);

            setStateModal({ visible: index });
          })
          .catch((error) => {
            setLoading(false);
          });
      } else {
        setStateModal({ visible: index });
      }
    } else {
      setStateModal({ visible: index });
    }
    console.log(item.QuickbookId, index, "index2345");
    setDeleteIndex(index);
    setID(item.ID);
    setviewregasterQuickbookIds(item.QuickbookId);
    setTransferquickbookid(item.Transferquickbookid);
    setDeposit(item.Deposit);
    setPayment(item.Payment);
    setTransactionTypeID(item.TransactionTypeID);
    setTransactionType(item.TransactionTypeID);
    setModuleDelete(item.Module);
  };

  //close
  const handleClose = () => {
    //setShowDeleteModal(false);
    setStateModal({ visible: null });
  };

  const handleConfirmDelete = (index) => {
    // const rows = [...rowsData];
    // rows.splice(deleteIndex, 1);
    // setRowsData(rows);

    setStateModal({ visible: null });
    axios
      .post(
        `${config.accountingBaseUrl}/chartofaccounts/viewregisterdelete`,
        // rowsData[index],
        {
          id: id,
          quickbookid: viewregasterQuickbookIds,
          Transferquickbookid: Transferquickbookid,
          Deposit: Deposit,
          Payment: Payment,
          rootquickbookid: fromQuickbookId,
          TransactionTypeID: TransactionTypeID,
          loginuserid: loginuserid,
          transactiontype: transactiontype,
          module: moduledelete,
          notlistingdata: notlistingdata,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setnotlistingdata([]);
        toastSuccess(SUCCESS_MESSAGE);
        handleViewRegisterAPI(
          searchText,
          selectTransaction,
          customerId,
          supplierId,
          beginningDate,
          finalDate,
          accountId,
          employeeId
        );
        AccountSaveAPI();
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const handleCancelDelete = () => {
    //setShowDeleteModal(false);
    setStateModal({ visible: null });
  };

  //Date
  const handleDate = (event) => {
    // console.log(event?.target?.value, "eventisss92");
    setBeginningDate(event?.target?.value);
    setCustomDate(7);
  };

  const handleEndDate = (event) => {
    setFinalDate(event?.target?.value);
    setCustomDate(7);
  };

  useEffect(() => {
    if (paramObject.id > 0) {
      setCustomDate(5);
      setBeginningDate(startOfYear);
      setFinalDate(endOfYear);
      setAccountId(paramObject.id);
    }
  }, []);

  useEffect(() => {
    if (accountId > 0) {
      handleViewRegisterAPI(
        searchText,
        selectTransaction,
        customerId,
        supplierId,
        beginningDate,
        finalDate,
        accountId,
        employeeId
      );
    }
  }, [
    searchText,
    selectTransaction,
    customerId,
    supplierId,
    beginningDate,
    finalDate,
    accountId,
  ]);

  useEffect(() => {
    AccountAPI();
    payeeAPI();
    transactionType();
  }, []);

  useEffect(() => {
    const filteredOptions = appointmentPersonOptions.filter((option) => {
      if (transactionid === 5 || transactionid === 7) {
        return option.UserType === "Supplier";
      } else if (transactionid === 11) {
        return option.UserType === "Customer";
      } else if (transactionid === 12 || transactionid === 14) {
        return option.UserType === "Customer" || option.UserType === "Supplier";
      } else if (transactionid === 6) {
        return (
          option.UserType === "Customer" ||
          option.UserType === "Supplier" ||
          option.UserType === "Employee"
        );
      }
      return false;
    });

    setNewPayeeDropdown(filteredOptions);
  }, [transactionid]);

  console.log(newPayeeDropdown, "newPayeeDropdown");

  const inputStyles = {
    width: "92%",
    display: "block",
    // padding: '0.375rem 0.75rem',
    fontSize: "12px",
    marginLeft: "5px",
    fontWeight: 400,
    lineHeight: 1.5,
    color: "#212529",
    // backgroundColor: '#fff',
    backgroundClip: "padding-box",
    border: "1px solid #ced4da",
    appearance: "none",
    borderRadius: "8px",
    transition: "border-color .15s ease-in-out, box-shadow .15s ease-in-out",
  };

  const addTableRows = () => {
    setDropdown(false);
    setShowRow(true);

    const rowsInput = {
      ID: 0,
      Account: "",
      AccountID: 0,
      Balance: 0,
      Date: "",
      Deposit: 0,
      Memo: "",
      Module: "",
      Payee: "",
      PayeeId: 0,
      PayeeUserType: "",
      Payment: 0,
      RefNo: "",
      RowNumber: 0,
      TransactionTypeID: 0,
      Type: "",
      cr: "",
      balance: 0,
      showDelete: false,
    };
    // setRowsData((prev) => {
    //   let prevData = [...prev];
    //   prevData = [rowsInput, ...prevData];
    //   return prevData
    // })
  };
  // console.log(rowsData, "rowsData")

  const Spilliting = (item) => {
    const items = item.split(",");
    // localStorage.setItem("Splits", JSON.stringify(items));
    setSplits(items);
  };
  // console.log(newRowData, "newRowData")

  const handleInvoiceChange = (event) => {
    console.log(event.map((el) => el.value).join(","), "eventt");
    setSelectedInvoice(event.map((el) => el.value).join(","));
  };

  const descRowsData = rowsData?.sort((a, b) => {
    return b?.row_num - a?.row_num;
  });

  const handleEdit = (value, id, isExpanse, RecSaleID) => {
    console.log(value, id, isExpanse, RecSaleID, "handelEdit");
    // return
    if (isExpanse === "Expense") {
      navigate(`/Expense/${RecSaleID}`);
    }

    if (value == 8 || value == 9) {
      navigate(`/manage-sales/${id}`);
    }

    if (value == 6) {
      navigate(`/Expense/${RecSaleID}`);
    }
    if (value == 5) {
      navigate(`/manage-receiving/${RecSaleID}`);
    }
    if (value == 3) {
      navigate(`/manage-receiving/${id}`);
    }

    if (value == 7) {
      navigate(`/receiving-paybills/${id}`);
    }

    if (value == 11) {
      navigate(`/receive-payment/${id}`);
    }

    if (value == 12) {
      navigate(`/bank-deposit/${id}`);
    }

    if (value == 13) {
      navigate(`/manage-transfer/${id}`);
    }

    if (value == 14) {
      navigate(`/journal-entry/${id}`);
    }
  };

  console.log(descRowsData, "descRowsData");
  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          {/* Page Header */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <div className="col"> */}
              {/* <h6 className="page-title">Accounting</h6> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/accounting">Account</Link>
                </li>
                <li className="breadcrumb-item active">View Register</li>
              </ul>
              {/* </div> */}
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <div className="col-lg-12 col-md-6 col-sm-12">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  {/* <div>
                    <div style={{ marginBottom: "10px" }}>
                      <div className="col-form-label">Find</div>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="find"
                        name="find"
                        onChange={(event) => setSearchText(event.target.value)}
                      />
                    </div>
                  </div> */}
                  {/* <div style={{ width: "12%" }}>
                    Recouncile Status:
                    <Select
                      // defaultValue={quickBookOptions}
                      // onChange={(event) => {
                      //   handleQuickBookChange(event);
                      // }}
                      options={recouncileStatusOption}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      isClearable={true}
                      value={recouncileStatusOption.find(
                        (option) => option?.value == selectRecouncile
                      )}
                      onChange={(event) => {
                        selectRecouncileHandle(event?.value);
                      }}
                    // hideSelectedOptions={true}
                    // styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                    />
                  </div> */}
                  <div style={{ width: "16%" }}>
                    <div className="col-form-label">Transaction Type</div>
                    <Select
                      // defaultValue={quickBookOptions}
                      // onChange={(event) => {
                      //   handleQuickBookChange(event);
                      // }}
                      options={transactionTypeDropdownOption}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      isClearable={true}
                      value={transactionTypeDropdownOption.find(
                        (option) => option?.value == selectTransaction
                      )}
                      onChange={(event) => {
                        selectTransactionHandle(event?.value);
                      }}
                      // hideSelectedOptions={true}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      className="custom-search-select"
                    />
                  </div>
                  <div style={{ width: "20%" }}>
                    <div className="col-form-label">Payee </div>
                    <Select
                      // defaultValue={quickBookOptions}
                      onChange={(event) => {
                        console.log(event, "eventdata");
                        handlePayeeType(event);
                      }}
                      options={appointmentPersonOptions}
                      value={appointmentPersonOptions.find(
                        (item) => item.value == ""
                      )}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      isClearable={true}
                      id="userid"
                      name="userid"
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      className="custom-search-select"
                    />
                  </div>
                  <div style={{ width: "17%" }}>
                    <div className="col-form-label"> Date </div>
                    <Select
                      // defaultValue={quickBookOptions}
                      onChange={(event) => {
                        handleDateFilter(event);
                      }}
                      options={dateOptions}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      isClearable={true}
                      defaultValue={5}
                      // hideSelectedOptions={true}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      value={dateOptions.find((el) => el?.value == customeDate)}
                      className="custom-search-select"
                    />
                  </div>
                  <div style={{ width: "12%" }}>
                    <div className="col-form-label">From</div>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      id="StartDate"
                      name="StartDate"
                      value={beginningDate}
                      // defaultValue={todayDate}
                      onChange={(event) => handleDate(event)}
                    />
                  </div>
                  <div style={{ width: "12%" }}>
                    <div className="col-form-label">To: </div>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      id="StartDate"
                      name="StartDate"
                      value={finalDate}
                      // defaultValue={todayDate}
                      onChange={(event) => handleEndDate(event)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ width: "60%", display: "flex" }}>
                  <button
                    disabled={setShowRow == true}
                    type="button"
                    className="btn btn-sm btn-secondary  btn-sm pull-left"
                    style={{ margin: "18px 30px 1px 0", height: "37px" }}
                    onClick={accountValue !== 5 && addTableRows}
                  >
                    <i className="fa fa-plus fa-sm" /> Add
                  </button>
                  <div className="col-md-6 mb-4 col-form-control">
                    <strong>Account</strong>
                    <Select
                      onChange={(e, i) => {
                        console.log(e, "eventdat==>");
                        setAccountId(e?.value);
                        setfromQuickbookId(e?.QuickbookId);
                        handleQuickBookChange(e, i);
                      }}
                      value={accountTypeDropdownOption.find(
                        (option) => option?.value == accountId //?.value
                      )}
                      options={accountTypeDropdownOption}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      isClearable={true}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      id="AccountId"
                      name="AccountId"
                      className="custom-search-select"
                    />
                  </div>
                </div>
                <div>
                  <p class="p-medium">Balance</p>
                  {/* <p className="text-right p">${amount ? amount : 0}</p> */}
                  {/* <p className="text-right p">${amountforAPandAR}</p> */}
                  <p className="text-right p">${amount ? amount : 0}</p>
                </div>
              </div>

              <div className="">
                <table
                  className="table custom-table"
                  style={{ width: "100%", textAlign: "center" }}
                >
                  <thead style={{ borderBottom: "1px solid #1a2649" }}>
                    <tr>
                      {/* <th style={{ width: "9.5rem" }}>Type</th> */}
                      {/* <th  name="Date" id="Date" onClick={(e) => handelSortByAscDesc(e)} style={{ width: "4rem", cursor:'pointer' }}>Date <i class='fa fa-sort'></i></th> */}
                      <th name="Date" id="Date" style={{ width: "4rem" }}>
                        Date
                      </th>
                      <th
                        onClick={(e) => handelSortByAscDesc(e)}
                        name="RefNo"
                        id="RefNo"
                        style={{ cursor: "pointer" }}
                      >
                        Ref No. <i class="fa fa-sort"></i>
                      </th>
                      <th
                        style={{ width: "10rem", cursor: "pointer" }}
                        onClick={(e) => handelSortByAscDesc(e)}
                        name="Payee"
                        id="Payee"
                      >
                        Payee <i class="fa fa-sort"></i>
                      </th>
                      {/* <th style={{ width: "10rem" }}>Account</th> */}
                      <th
                        name="Payment"
                        id="Payment"
                        onClick={(e) => handelSortByAscDesc(e)}
                        style={{ cursor: "pointer" }}
                      >
                        {accountId == 1 || accountId == 5
                          ? "Charge/Credit"
                          : "Payment(DR)"}{" "}
                        <i class="fa fa-sort"></i>
                      </th>
                      <th
                        name="Deposit"
                        id="Deposit"
                        onClick={(e) => handelSortByAscDesc(e)}
                        style={{ cursor: "pointer" }}
                      >
                        {accountId == 1 || accountId == 5
                          ? "Payment"
                          : "Deposit(CR)"}{" "}
                        <i class="fa fa-sort"></i>
                      </th>
                      <th name="cr" id="cr" style={{ padding: "0px" }}>
                        C/R
                      </th>
                      <th
                        name="Balance"
                        id="Balance"
                        onClick={(e) => handelSortByAscDesc(e)}
                        style={{ cursor: "pointer" }}
                      >
                        Balance <i class="fa fa-sort"></i>
                      </th>
                      {/* <th>Action</th> */}
                    </tr>
                    <tr>
                      <th></th>
                      <th
                        name="Type"
                        id="Type"
                        onClick={(e) => handelSortByAscDesc(e)}
                        style={{ cursor: "pointer" }}
                      >
                        Type <i class="fa fa-sort"></i>
                      </th>
                      <th
                        name="AccountID"
                        id="AccountID"
                        onClick={(e) => handelSortByAscDesc(e)}
                        style={{ width: "10rem", cursor: "pointer" }}
                      >
                        Account <i class="fa fa-sort"></i>
                      </th>
                      <th style={{ width: "10rem" }}></th>
                      <th>
                        {" "}
                        {accountId == 1 || accountId == 5 ? "DueDate" : ""}
                      </th>
                      <th></th>
                      {/* <th></th> */}
                      <th style={{ width: "4rem" }}></th>
                      {/* <th></th> */}
                      {/* <th></th> */}
                    </tr>
                    <tr>
                      <th></th>
                      <th></th>
                      <th
                        name="Memo"
                        id="Memo"
                        onClick={(e) => handelSortByAscDesc(e)}
                        style={{ cursor: "pointer" }}
                      >
                        Memo <i class="fa fa-sort"></i>
                      </th>
                      <th style={{ width: "10rem" }}></th>
                      <th></th>
                      <th></th>
                      {/* <th></th> */}
                      <th style={{ width: "4rem" }}></th>
                      {/* <th></th> */}
                      {/* <th></th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {showRow &&
                      newRowData.map((item, index) => {
                        return (
                          <>
                            <tr style={{ borderBottom: "1px solid #1a2649" }}>
                              {/* <td style={{ padding: "1px",textAlign: "-webkit-center", "background-color": "#ffe6ce" }}>
                                <>
                                  <Select
                                    onChange={(event) => handleNewInputChange(event, "Type")}
                                    options={transactionTypeDropdownOption}
                                    backspaceRemovesValue={false}
                                    controlShouldRenderValue={true}
                                    styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                                    className="mt-1"
                                    id="Type"
                                    name="Type"
                                  />
                                </>
                              </td> */}
                              <td
                                style={{
                                  padding: "1px",
                                  textAlign: "-webkit-center",
                                  verticalAlign: "-webkit-baseline-middle",
                                  width: "10%",
                                  "background-color": "#ededed",
                                  fontSize: "12px",
                                  // borderBottom:"1px solid red"
                                }}
                              >
                                <input
                                  value={newRowData[0].Date}
                                  className="form-control form-control-sm mt-2 mb-2 ml-2 "
                                  style={{ width: "85%" }}
                                  type="date"
                                  id="date"
                                  name="date"
                                  onChange={(event) =>
                                    handleNewInputChange(event, "Date")
                                  }
                                />
                              </td>
                              <td
                                style={{
                                  padding: "1px",
                                  verticalAlign: "-webkit-baseline-middle",
                                  "background-color": "#ededed",
                                  width: "30%",
                                  // border: "1px solid red",
                                  lineHeight: "20px",
                                  fontSize: "12px",
                                }}
                              >
                                <input
                                  className="form-control form-control-sm  mt-2 mb-2 "
                                  type="text"
                                  id="refno"
                                  name="refno"
                                  placeholder="Reference No."
                                  style={inputStyles}
                                  onChange={(event) =>
                                    handleNewInputChange(
                                      event?.target?.value,
                                      "RefNo"
                                    )
                                  }
                                  disabled={
                                    transactionid == 12 || transactionid == 13
                                  }
                                />
                                <Select
                                  onChange={(event) =>
                                    handleNewInputChange(event, "Type")
                                  }
                                  options={newTransactionTypeDropdownOption}
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                  placeholder="type"
                                  className="custom-search-select col-md-11  mt-3 mb-2 ml-2"
                                  id="Type"
                                  name="Type"
                                />
                              </td>
                              <td
                                style={{
                                  padding: "1px",
                                  verticalAlign: "-webkit-baseline-middle",
                                  "background-color": "#ededed",
                                  width: "50%",
                                  fontSize: "12px",
                                }}
                              >
                                <Select
                                  onChange={(event) =>
                                    handleNewInputChange(event, "PayeeId")
                                  }
                                  options={newPayeeDropdown}
                                  // options={appointmentPersonOptions}
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  className="custom-search-select col-md-11 mt-3 mb-2 ml-2"
                                  // placeholder="payee"
                                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                  id="Payee"
                                  name="Payee"
                                  placeholder={
                                    transactionid === 0
                                      ? "Please Select the Transaction Type First"
                                      : "Payee"
                                  }
                                  isDisabled={transactionid == 13}
                                />
                                {/* {dropdown ? <Select
                                  onChange={(event) => handleInvoiceChange(event)}
                                  options={invoicedatadropdown}
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  hideSelectedOptions={true}
                                  className="custom-search-select col-md-12"
                                  placeholder={
                                    transactionid === 7
                                      ? "Bill No."
                                      : transactionid === 11
                                      ? "Invoice No"
                                      : ""
                                  }
                                  id="Payee"
                                  name="Payee"
                                /> : ""} */}
                                <Select
                                  onChange={(event) =>
                                    handleNewInputChange(event, "AccountID")
                                  }
                                  options={accountTypeDropdownOption}
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  hideSelectedOptions={true}
                                  isClearable={true}
                                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                  placeholder="Account"
                                  id="AccountId"
                                  name="AccountId"
                                  className="custom-search-select mt-3 col-md-11 ml-2"
                                  isDisabled={
                                    transactionid == 5 ||
                                    transactionid == 7 ||
                                    transactionid == 11
                                  }
                                />

                                <input
                                  className="form-control form-control-sm col-md-12  mt-3 mb-3"
                                  type="text"
                                  style={inputStyles}
                                  placeholder="Memo"
                                  onChange={(event) =>
                                    handleNewInputChange(event, "Memo")
                                  }
                                />
                              </td>
                              {/* <td style={{ padding: "1px",textAlign: "-webkit-center", "background-color": "#ffe6ce" }}>
                                <Select
                                  onChange={(event) => handleNewInputChange(event, "AccountID")}
                                  options={accountTypeDropdownOption}
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  hideSelectedOptions={true}
                                  isClearable={true}
                                  styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                                  id="AccountId"
                                  name="AccountId"
                                  className="custom-search-select"
                                />
                              </td> */}
                              {/* <td
                                style={{
                                  padding: "1px",
                                  verticalAlign: "-webkit-baseline-middle",
                                  width: "35%",
                                  "background-color": "#ededed",
                                  fontSize: "12px",
                                }}
                              >
                               
                              
                              </td> */}
                              <td
                                style={{
                                  padding: "1px",
                                  textAlign: "left",
                                  verticalAlign: "-webkit-baseline-middle",
                                  width: "26%",
                                  lineHeight: "20px",
                                  "background-color": "#ededed",
                                  fontSize: "12px",
                                }}
                              >
                                <input
                                  className="form-control form-control-sm"
                                  type="number"
                                  style={{ width: "108px", fontSize: "12px" }}
                                  placeholder="Payment(DR)"
                                  // style={inputStyles}
                                  disabled={
                                    transactionid == 11 || transactionid == 12
                                  }
                                  onChange={(event) =>
                                    handleNewInputChange(event, "Payment")
                                  }
                                  value={item?.Payment}
                                  // defaultValue={newRowData[0].Type==7 ? paymentamount:null}
                                />
                                {dropdown ? (
                                  <Select
                                    // value={invoicedatadropdown.find((option)=>option.value==selectedinvoice)}
                                    // onChange={(event) => handleInvoiceChange(event)}
                                    onChange={(value) =>
                                      handleNewInputChange(value, "BillInvoice")
                                    }
                                    options={invoicedatadropdown}
                                    backspaceRemovesValue={false}
                                    controlShouldRenderValue={true}
                                    hideSelectedOptions={true}
                                    // styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                                    styles={selectDropdownStyles}
                                    // isMulti={true}
                                    isClearable={true}
                                    className="col-md-11 mt-3 custom-search-select"
                                    placeholder={
                                      transactionid === 7
                                        ? "Bill No."
                                        : transactionid === 11
                                        ? "Invoice No"
                                        : ""
                                    }
                                    id="BillInvoice"
                                    name="BillInvoice"
                                  />
                                ) : (
                                  ""
                                )}
                                {newRowData[0]?.Type == 7
                                  ? labelinvoice?.map((item, index) => {
                                      return (
                                        <div>
                                          <p key={index}>
                                            {item.label.split("(")[0].trim()}:{" "}
                                            {item.total}
                                          </p>
                                        </div>
                                      );
                                    })
                                  : null}
                              </td>
                              <td
                                style={{
                                  padding: "1px",
                                  textAlign: "left",
                                  verticalAlign: "-webkit-baseline-middle",
                                  "background-color": "#ededed",
                                  width: "27%",
                                  fontSize: "12px",
                                }}
                              >
                                <input
                                  className="form-control form-control-sm"
                                  type="number"
                                  // style={inputStyles}
                                  style={{ width: "99px", fontSize: "12px" }}
                                  placeholder="Deposit(CR)"
                                  onChange={(event) =>
                                    handleNewInputChange(event, "Deposit")
                                  }
                                  disabled={
                                    transactionid == 7 ||
                                    transactionid == 5 ||
                                    transactionid == 6
                                      ? true
                                      : false
                                  }
                                  value={item?.Deposit}
                                  // defaultValue={newRowData[0].Type==11 ? paymentamount:null}
                                />
                                {newRowData[0]?.Type == 11
                                  ? labelinvoice?.map((item, index) => {
                                      return (
                                        <div>
                                          <p key={index}>
                                            {item.label.split("(")[0].trim()}:{" "}
                                            {item.total}
                                          </p>
                                        </div>
                                      );
                                    })
                                  : null}
                              </td>
                              <td
                                style={{
                                  padding: "1px",
                                  textAlign: "-webkit-center",
                                  verticalAlign: "-webkit-baseline-middle",
                                  "background-color": "#ededed",
                                  width: "27%",
                                  fontSize: "12px",
                                }}
                              >
                                <input
                                  value={newRowData[0].cr}
                                  className="form-control form-control-sm"
                                  style={{
                                    fontSize: "12px",
                                    width: "45px",
                                    cursor: "pointer",
                                  }}
                                  // placeholder="C/R"
                                  type="text"
                                  onClick={handleInputClick}
                                  readOnly
                                />
                                <td></td>
                                <button
                                  type="button"
                                  class="btn btn-primary  mr-2"
                                  onClick={() => handleSubmit("add")}
                                >
                                  Save
                                </button>
                                <div class="row">
                                  <div class="col-md-12">{}</div>
                                </div>
                              </td>
                              <td
                                style={{
                                  padding: "1px",
                                  textAlign: "-webkit-center",
                                  verticalAlign: "-webkit-baseline-middle",
                                  "background-color": "#ededed",
                                  width: "27%",
                                  fontSize: "12px",
                                }}
                              >
                                <p className="mb-2">0</p>
                                <td></td>
                                <td></td>
                                <div>
                                  <button
                                    type="button"
                                    class="btn btn-secondary mt-2"
                                    onClick={() => handleRemove()}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </td>

                              {/* <td style={{ padding: "1px",textAlign: "-webkit-center", "background-color": "#ffe6ce" }}>
                                <div class="row">
                                  <div class="col-md-12">
                                    {
                                      <>
                                        <button type="button" class="btn btn-outline-primary  btn-sm btn-custom-padding mr-1" onClick={() => handleSubmit("add")}>
                                          <i class="fa fa-check" ></i>
                                        </button>
                                        <button type="button" class="btn btn-outline-dark btn-sm btn-custom-padding mr-1" onClick={() => handleRemove()}>
                                          <i class="fa fa-times"></i>
                                        </button>
                                      </>
                                    }
                                  </div>
                                </div>
                              </td> */}
                            </tr>
                          </>
                        );
                      })}

                    {showSortData
                      ? viewRegisterData?.map((item, index) => {
                          // return accountValue === 5 ? (
                          //   ""
                          // ) :
                          return (
                            <tr>
                              {/* <td style={{ padding: "1px" textAlign: "-webkit-center",}}>
                                  <>
                                    <Select
                                      // onChange={(event) => {
                                      //   handleAccountType(event)
                                      // }}
                                      // value={transactionTypeDropdownOption?.find((option) => option?.value === item?.TransactionTypeID)}
                                      defaultValue={transactionTypeDropdownOption?.find((option) => option?.value === item?.TransactionTypeID)}
                                      onChange={(event) => handleInputChange(event?.value, index, "Type")}
                                      options={transactionTypeDropdownOption}
                                      backspaceRemovesValue={false}
                                      controlShouldRenderValue={true}
                                      styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                                      className="mt-1"
                                      id="Type"
                                      name="Type"
                                      isDisabled={paramObject.id > 0 ? true : false}
                                    // isOptionDisabled={true}
                                    />
                                  </>
                                </td> */}
                              <td
                                style={{
                                  padding: "1px",
                                  textAlign: "-webkit-center",
                                  verticalAlign: "-webkit-baseline-middle",
                                  width: "10%",
                                  fontSize: "12px",
                                }}
                              >
                                <input
                                  className="form-control form-control-sm ml-2"
                                  type="date"
                                  id="date"
                                  name="date"
                                  // style={{
                                  //   height: "31px",
                                  //   width: "85%",
                                  //   marginTop: "2px",
                                  // }}
                                  style={{ width: "85%" }}
                                  defaultValue={moment(item?.Date).format(
                                    "YYYY-MM-DD"
                                  )}
                                  onChange={(event) =>
                                    handleInputChange(event, index, "Date")
                                  }
                                  disabled={item?.IsDefaultBalance == 1}
                                />
                              </td>
                              <td
                                style={{
                                  padding: "1px",
                                  verticalAlign: "-webkit-baseline-middle",
                                  width: "36%",
                                  marginLeft: "2px",
                                  lineHeight: "20px",
                                  // border: "1px solid red",
                                  fontSize: "12px",
                                }}
                              >
                                <input
                                  className="form-control form-control-sm col-md-12 "
                                  type="text"
                                  id="refno"
                                  name="refno"
                                  placeholder="Reference No."
                                  style={{
                                    ...inputStyles,
                                    backgroundColor:
                                      item?.TransactionTypeID === 12 ||
                                      item?.TransactionTypeID === 13
                                        ? "dark"
                                        : "",
                                  }}
                                  onChange={(event) =>
                                    handleInputChange(
                                      event?.target?.value,
                                      index,
                                      "RefNo"
                                    )
                                  }
                                  defaultValue={item?.RefNo}
                                  disabled={
                                    item?.TransactionTypeID == 12 ||
                                    item?.TransactionTypeID == 13
                                      ? true
                                      : false
                                  }
                                />
                                {/* <td style={{ padding: "1px",textAlign: "-webkit-center",width:"176px" }}>
                                    <> */}
                                <Select
                                  // onChange={(event) => {
                                  //   handleAccountType(event)
                                  // }}
                                  // value={transactionTypeDropdownOption?.find((option) => option?.value === item?.TransactionTypeID)}
                                  defaultValue={transactionTypeDropdownOption?.find(
                                    (option) =>
                                      option?.value === item?.TransactionTypeID
                                  )}
                                  onChange={(event) =>
                                    handleInputChange(
                                      event?.value,
                                      index,
                                      "Type"
                                    )
                                  }
                                  options={transactionTypeDropdownOption}
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                  className="custom-search-select col-md-11 mt-3 ml-2"
                                  placeholder="type"
                                  id="Type"
                                  name="Type"
                                  isDisabled={paramObject.id > 0 ? true : false}
                                  // isOptionDisabled={true}
                                />
                                {/* </> */}
                                {/* </td> */}
                              </td>
                              <td
                                style={{
                                  padding: "1px",
                                  verticalAlign: "-webkit-baseline-middle",
                                  lineHeight: "20px",
                                  width: "50%",
                                  fontSize: "12px",
                                }}
                              >
                                {item.IsCustomerSplit == 1 ? (
                                  <>
                                    <button
                                      className="btn btn-sm btn-outline-primary btn-custom-padding col-md-11  mt-2 ml-2"
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      data-bs-toggle="modal"
                                      data-bs-target="#SplittingConfirmationModal"
                                      onClick={() =>
                                        Spilliting(item.SplitRecords)
                                      }
                                      // style={{ width: "100%" }}
                                    >
                                      -Split-
                                    </button>
                                  </>
                                ) : (
                                  <Select
                                    // onChange={(event) => {
                                    //   handleAppointmentPerson(event)
                                    // }}
                                    onChange={(event) =>
                                      handleInputChange(event, index, "PayeeId")
                                    }
                                    options={
                                      item?.showAll
                                        ? appointmentPersonOptions
                                        : appointmentPersonOptions?.filter(
                                            (el) =>
                                              el?.UserType ===
                                              item?.PayeeUserType
                                          )
                                    }
                                    backspaceRemovesValue={false}
                                    controlShouldRenderValue={true}
                                    value={appointmentPersonOptions
                                      ?.filter(
                                        (el) =>
                                          el?.UserType === item?.PayeeUserType
                                      )
                                      ?.find(
                                        (option) =>
                                          option?.value == item?.PayeeId
                                      )}
                                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                    placeholder={
                                      transactionid === 0
                                        ? "Please Select the Transaction Type First"
                                        : "Payee"
                                    }
                                    id="Payee"
                                    name="Payee"
                                    className="custom-search-select col-md-11 ml-2"
                                    isDisabled={
                                      item?.TransactionTypeID == 12 ||
                                      item?.TransactionTypeID == 11 ||
                                      item?.TransactionTypeID == 13 ||
                                      item?.TransactionTypeID == 7
                                        ? true
                                        : false
                                    }
                                  />
                                )}
                                {/* {item?.PayeeId} :  12 */}
                                {/* <td style={{ padding: "1px" textAlign: "-webkit-center",}}> */}
                                {item.IsSplit == 1 ? (
                                  <>
                                    <button
                                      className="btn btn-sm btn-outline-primary btn-custom-padding col-md-11  mt-2 ml-2"
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      data-bs-toggle="modal"
                                      data-bs-target="#SplittingConfirmationModal"
                                      onClick={() =>
                                        Spilliting(item.SplitRecords)
                                      }
                                      // style={{ width: "100%" }}
                                    >
                                      -Split-
                                    </button>
                                  </>
                                ) : (
                                  <Select
                                    // onChange={(e, i) => {
                                    //   setAccountId(e?.value);
                                    //   handleQuickBookChange(e, i);
                                    // }}
                                    onChange={(event) =>
                                      handleInputChange(
                                        event,
                                        index,
                                        "AccountID"
                                      )
                                    }
                                    value={accountTypeDropdownOption.find(
                                      (option) =>
                                        option?.value == item?.AccountID
                                    )}
                                    options={accountTypeDropdownOption}
                                    backspaceRemovesValue={false}
                                    controlShouldRenderValue={true}
                                    hideSelectedOptions={true}
                                    isClearable={true}
                                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                    id="AccountId"
                                    name="AccountId"
                                    // isDisabled={item?.IsDefaultBalance == 1}
                                    isDisabled={
                                      item?.TransactionTypeID == 3 ||
                                      item?.TransactionTypeID == 8 ||
                                      item?.TransactionTypeID == 9 ||
                                      item?.IsDefaultBalance == 1
                                        ? true
                                        : false
                                    }
                                    className="custom-search-select mt-3 col-md-11 ml-2"
                                  />
                                )}
                                <input
                                  className="form-control form-control-sm mt-3 col-md-12"
                                  type="text"
                                  style={inputStyles}
                                  placeholder="Memo"
                                  onChange={(event) =>
                                    handleInputChange(event, index, "Memo")
                                  }
                                  value={item?.Memo}
                                  // disabled={item?.IsDefaultBalance === 1}
                                  isDisabled={
                                    item?.TransactionTypeID == 3 ||
                                    item?.TransactionTypeID == 8 ||
                                    item?.TransactionTypeID == 9 ||
                                    item?.IsDefaultBalance === 1
                                      ? true
                                      : false
                                  }
                                />
                                {/* {item?.TransactionTypeID} */}
                                {/* <span className="ml-2">{item?.AmountPaid}</span>
                                <br></br>
                                <span className="ml-2">{item?.CreditNote}</span> */}
                                {/* </td> */}
                              </td>
                              {/* <td style={{ padding: "1px" textAlign: "-webkit-center",}}>

                                  {item.IsSplit == 1 ?
                                    <>
                                      <button className="btn btn-sm btn-outline-primary btn-custom-padding" data-toggle="tooltip" data-placement="bottom"
                                        data-bs-toggle="modal"
                                        data-bs-target="#SplittingConfirmationModal"
                                        onClick={() => Spilliting(item.SplitRecords)}
                                        style={{ "width": "100%" }}>

                                        -Split-
                                      </button>
                                    </>
                                    : <Select
                                      // onChange={(e, i) => {
                                      //   setAccountId(e?.value);
                                      //   handleQuickBookChange(e, i);
                                      // }}
                                      onChange={(event) => handleInputChange(event, index, "AccountID")}
                                      value={accountTypeDropdownOption.find(
                                        (option) => option?.value == item?.AccountID
                                      )}
                                      options={accountTypeDropdownOption}
                                      backspaceRemovesValue={false}
                                      controlShouldRenderValue={true}
                                      hideSelectedOptions={true}
                                      isClearable={true}
                                      styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                                      id="AccountId"
                                      name="AccountId"
                                      isDisabled={item?.IsDefaultBalance == 1}
                                    />

                                  }
                                </td> */}
                              {/* <td
                            style={{
                              
                              verticalAlign: "-webkit-baseline-middle",
                              width: "35%",
                              fontSize: "12px",
                            }}
                          >
                            
                          </td> */}
                              <td
                                style={{
                                  // padding: "1px",
                                  textAlign: "-webkit-center",
                                  verticalAlign: "-webkit-baseline-middle",
                                  width: "27%",
                                  fontSize: "12px",
                                }}
                              >
                                <input
                                  className="form-control form-control-sm "
                                  type="number"
                                  style={{ width: "99px", fontSize: "12px" }}
                                  // style={inputStyles}
                                  value={item?.Payment}
                                  onChange={(event) =>
                                    handleInputChange(event, index, "Payment")
                                  }
                                  disabled={
                                    item?.TransactionTypeID == 12 ||
                                    item?.TransactionTypeID == 7 ||
                                    item?.TransactionTypeID == 11 ||
                                    item?.TransactionTypeID == 14 ||
                                    (item?.TransactionTypeID == 6 &&
                                      item?.IsSplit == 1) ||
                                    (item?.TransactionTypeID == 13 &&
                                      item?.Payment == 0) ||
                                    item?.IsDefaultBalance == 1
                                      ? true
                                      : false
                                  }
                                />
                              </td>
                              <td
                                style={{
                                  padding: "1px",
                                  textAlign: "-webkit-center",
                                  verticalAlign: "-webkit-baseline-middle",
                                }}
                              >
                                <input
                                  className="form-control form-control-sm"
                                  type="number"
                                  style={{ width: "99px", fontSize: "12px" }}
                                  // style={inputStyles}
                                  value={item?.Deposit}
                                  onChange={(event) =>
                                    handleInputChange(event, index, "Deposit")
                                  }
                                  disabled={
                                    (item?.TransactionTypeID == 12 &&
                                      item?.Deposit == 0 &&
                                      item?.IsSplit == 1) ||
                                    item?.TransactionTypeID == 14 ||
                                    item?.TransactionTypeID == 11 ||
                                    item?.TransactionTypeID == 6 ||
                                    item?.TransactionTypeID == 7 ||
                                    item?.TransactionTypeID == 13 ||
                                    item?.IsDefaultBalance == 1
                                      ? true
                                      : false
                                  }
                                />
                                <td>
                                  <span className="ml-2">
                                    {accountId == 1 || accountId == 5
                                      ? `${
                                          item?.DueDate
                                            ? moment(item?.DueDate).format(
                                                "YYYY-MM-DD"
                                              )
                                            : ""
                                        }`
                                      : ""}
                                  </span>
                                  <br></br>
                                  <span className="ml-2">
                                    {item?.AmountPaid}
                                  </span>
                                  <br></br>
                                  <span className="ml-2">
                                    {item?.CreditNote}
                                  </span>
                                </td>
                                {item?.Deleted !== 1 && (
                                  <button
                                    type="button"
                                    class="btn btn-primary btn-sm mr-1 "
                                    onClick={() =>
                                      handleSubmit("edit", index, item.IsSplit)
                                    }
                                  >
                                    Save
                                  </button>
                                )}
                              </td>
                              <td
                                style={{
                                  padding: "1px",
                                  textAlign: "-webkit-center",
                                  verticalAlign: "-webkit-baseline-middle",
                                  width: "27%",
                                  // border: "1px solid red",
                                  fontSize: "12px",
                                }}
                              >
                                <input
                                  value={rowsData[index].cr}
                                  className="form-control form-control-sm"
                                  // style={inputStyles}
                                  style={{
                                    fontSize: "12px",
                                    width: "45px",
                                    cursor: "pointer",
                                  }}
                                  //placeholder="C/R"
                                  type="text"
                                  onClick={() => handleRowInputClick(index)}
                                  // onChange={(event) => handleInputChange(event, index, "cr")}
                                  disabled={item?.IsDefaultBalance === 1}
                                  readOnly
                                />
                                <td></td>
                                {item?.Deleted !== 1 && (
                                  <button
                                    type="button"
                                    class="btn btn-secondary btn-sm mb-1 mr-1"
                                    onClick={() =>
                                      handleEdit(
                                        item?.TransactionTypeID,
                                        item?.ID,
                                        item?.Type,
                                        item?.RecSaleID
                                      )
                                    }
                                  >
                                    Edit
                                  </button>
                                )}
                              </td>
                              <td
                                style={{
                                  padding: "1px",
                                  textAlign: "-webkit-center",
                                  verticalAlign: "-webkit-baseline-middle",
                                  width: "27%",
                                  // border: "1px solid red",
                                  fontSize: "12px",
                                }}
                              >
                                {item?.Balance < 0 ? (
                                  <p className="mb-2" style={{ color: "red" }}>
                                    {item.Balance}
                                  </p>
                                ) : (
                                  <p className="mb-2">{item?.Balance}</p>
                                )}
                                <td></td>
                                <td></td>
                                {item?.IsDefaultBalance != 1 ? (
                                  <div class="row">
                                    <div class="col-md-12">
                                      {
                                        <>
                                          {item.IsDefaultBalance == 0 &&
                                            item?.Deleted !== 1 && (
                                              <>
                                                <button
                                                  type="button"
                                                  class="btn btn-secondary btn-sm  mt-1"
                                                  onClick={() =>
                                                    handleDeleteClick(
                                                      item,
                                                      index
                                                    )
                                                  }
                                                >
                                                  Delete
                                                </button>
                                              </>
                                            )}
                                        </>
                                      }
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                <div
                                  className={`modal ${
                                    stateModal.visible === index
                                      ? "d-block"
                                      : ""
                                  }`}
                                  tabIndex="-1"
                                  style={{ background: "rgba(0,0,0,0.2)" }}
                                >
                                  <div className="modal-dialog modal-dialog-centered">
                                    <div className="modal-content">
                                      <div className="modal-header">
                                        <h5 className="modal-title">
                                          Confirmation
                                        </h5>
                                        <button
                                          type="button"
                                          className="btn-close"
                                          data-bs-dismiss="modal"
                                          aria-label="Close"
                                          onClick={handleClose}
                                        >
                                          <span aria-hidden="true">×</span>
                                        </button>
                                      </div>
                                      <div className="modal-body">
                                        <div className="row">
                                          <div className="col-lg-12">
                                            <p className="mb-2">
                                              Are you sure you want to delete
                                              this row?
                                            </p>
                                            {false == 1 && (
                                              <>
                                                <p className=" text-danger">
                                                  Note: Credit delete need to
                                                  deleted manually
                                                </p>
                                                <p className=" text-danger">
                                                  from the QuickBook because it
                                                  won't SYNC.
                                                </p>
                                              </>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="modal-footer justify-content-center">
                                        <button
                                          type="button"
                                          className="btn btn-primary mt-5"
                                          onClick={() => handleConfirmDelete()}
                                        >
                                          Delete
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-secondary"
                                          onClick={handleCancelDelete}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </td>

                              {/* <td style={{ padding: "1px",textAlign: "-webkit-center",verticalAlign: "-webkit-baseline-middle"}}> */}
                              {/* <div class="row">
                                    <div class="col-md-12">
                                      {
                                        <>
                                          {
                                            item.IsDefaultBalance == 0 && (<button type="button" class="btn btn-outline-primary  btn-sm btn-custom-padding mr-1" onClick={() => handleSubmit("edit", index, item.IsSplit)}>
                                              <i class="fa fa-check" ></i>
                                            </button>)
                                          }
                                          {
                                            item.showDelete && item.IsDefaultBalance == 0 && (
                                              <button type="button" class="btn btn-outline-danger  btn-sm btn-custom-padding mr-1" onClick={() => handleDeleteClick(item, index)}>
                                                <i class="fa fa-trash"></i>
                                              </button>
                                            )
                                          }
                                        </>
                                      }
                                    </div>
                                  </div> */}
                              {/* Delete confirmation modal */}
                              {/* <div
                                    className={`modal ${stateModal.visible === index ? "d-block" : ""}`}
                                    tabIndex="-1"
                                    style={{ background: "rgba(0,0,0,0.2)" }}
                                  >
                                    <div className="modal-dialog modal-dialog-centered">
                                      <div className="modal-content">
                                        <div className="modal-header">
                                          <h5 className="modal-title">Confirmation</h5>
                                          <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            onClick={handleClose}
                                          >
                                            <span aria-hidden="true">×</span>
                                          </button>
                                        </div>
                                        <div className="modal-body">
                                          <div className="row">
                                            <div className="col-lg-12">
                                              <h6>Are you sure you want to delete this row?</h6>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="modal-footer justify-content-center">
                                          <button type="button" className="btn btn-primary" onClick={() => handleConfirmDelete()}>
                                            Delete
                                          </button>
                                          <button type="button" className="btn btn-secondary" onClick={handleCancelDelete}>
                                            Cancel
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div> */}
                              {/* </td> */}
                            </tr>
                          );
                        })
                      : descRowsData?.map((item, index) => {
                          // return accountValue === 5 ? (
                          //   ""
                          // ) :
                          return (
                            <tr
                              style={{
                                borderBottom:
                                  "1px solid var(--primary-color-50)",
                                marginBottom: "10px",
                              }}
                            >
                              {/* <td style={{ padding: "1px" textAlign: "-webkit-center",}}>
                                  <>
                                    <Select
                                      // onChange={(event) => {
                                      //   handleAccountType(event)
                                      // }}
                                      // value={transactionTypeDropdownOption?.find((option) => option?.value === item?.TransactionTypeID)}
                                      defaultValue={transactionTypeDropdownOption?.find((option) => option?.value === item?.TransactionTypeID)}
                                      onChange={(event) => handleInputChange(event?.value, index, "Type")}
                                      options={transactionTypeDropdownOption}
                                      backspaceRemovesValue={false}
                                      controlShouldRenderValue={true}
                                      styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                                      className="mt-1"
                                      id="Type"
                                      name="Type"
                                      isDisabled={paramObject.id > 0 ? true : false}
                                    // isOptionDisabled={true}
                                    />
                                  </>
                                </td> */}
                              <td
                                style={{
                                  padding: "1px",
                                  textAlign: "-webkit-center",
                                  verticalAlign: "-webkit-baseline-middle",
                                  width: "10%",
                                  fontSize: "12px",
                                }}
                              >
                                <input
                                  className="form-control form-control-sm ml-2"
                                  type="date"
                                  id="date"
                                  name="date"
                                  // style={{
                                  //   height: "31px",
                                  //   width: "85%",
                                  //   marginTop: "2px",
                                  // }}
                                  style={{ width: "85%" }}
                                  defaultValue={moment(item?.Date).format(
                                    "YYYY-MM-DD"
                                  )}
                                  onChange={(event) =>
                                    handleInputChange(event, index, "Date")
                                  }
                                  // disabled={item?.IsDefaultBalance == 1}
                                  disabled={
                                    item?.TransactionTypeID == 3 ||
                                    item?.TransactionTypeID == 8 ||
                                    item?.TransactionTypeID == 9 ||
                                    item?.IsDefaultBalance == 1
                                      ? true
                                      : false
                                  }
                                />
                              </td>
                              <td
                                style={{
                                  padding: "1px",
                                  verticalAlign: "-webkit-baseline-middle",
                                  width: "36%",
                                  marginLeft: "2px",
                                  lineHeight: "20px",
                                  // border: "1px solid red",
                                  fontSize: "12px",
                                }}
                              >
                                <input
                                  className="form-control form-control-sm col-md-12 "
                                  type="text"
                                  id="refno"
                                  name="refno"
                                  placeholder="Reference No."
                                  style={{
                                    ...inputStyles,
                                    backgroundColor:
                                      item?.TransactionTypeID === 12 ||
                                      item?.TransactionTypeID === 13
                                        ? "dark"
                                        : "",
                                  }}
                                  onChange={(event) =>
                                    handleInputChange(
                                      event?.target?.value,
                                      index,
                                      "RefNo"
                                    )
                                  }
                                  defaultValue={item?.RefNo}
                                  disabled={
                                    item?.TransactionTypeID == 12 ||
                                    item?.TransactionTypeID == 13 ||
                                    item?.TransactionTypeID == 3 ||
                                    item?.TransactionTypeID == 8 ||
                                    item?.TransactionTypeID == 9
                                      ? true
                                      : false
                                  }
                                />
                                {/* <td style={{ padding: "1px",textAlign: "-webkit-center",width:"176px" }}>
                                    <> */}
                                <Select
                                  // onChange={(event) => {
                                  //   handleAccountType(event)
                                  // }}
                                  // value={transactionTypeDropdownOption?.find((option) => option?.value === item?.TransactionTypeID)}
                                  defaultValue={transactionTypeDropdownOption?.find(
                                    (option) =>
                                      option?.value === item?.TransactionTypeID
                                  )}
                                  onChange={(event) =>
                                    handleInputChange(
                                      event?.value,
                                      index,
                                      "Type"
                                    )
                                  }
                                  options={transactionTypeDropdownOption}
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                  className="custom-search-select col-md-11 mt-3 ml-2"
                                  placeholder="type"
                                  id="Type"
                                  name="Type"
                                  isDisabled={paramObject.id > 0 ? true : false}
                                  // isOptionDisabled={true}
                                />
                                {/* </> */}
                                {/* </td> */}
                              </td>
                              <td
                                style={{
                                  padding: "1px",
                                  verticalAlign: "-webkit-baseline-middle",
                                  lineHeight: "20px",
                                  width: "50%",
                                  fontSize: "12px",
                                }}
                              >
                                {item.IsCustomerSplit == 1 ? (
                                  <>
                                    <button
                                      className="btn btn-sm btn-outline-primary btn-custom-padding col-md-11  mt-2 ml-2"
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      data-bs-toggle="modal"
                                      data-bs-target="#SplittingConfirmationModal"
                                      onClick={() =>
                                        Spilliting(item.SplitRecords)
                                      }
                                      // style={{ width: "100%" }}
                                    >
                                      -Split-
                                    </button>
                                  </>
                                ) : (
                                  <Select
                                    // onChange={(event) => {
                                    //   handleAppointmentPerson(event)
                                    // }}
                                    onChange={(event) =>
                                      handleInputChange(event, index, "PayeeId")
                                    }
                                    options={
                                      item?.showAll
                                        ? appointmentPersonOptions
                                        : appointmentPersonOptions?.filter(
                                            (el) =>
                                              el?.UserType ===
                                              item?.PayeeUserType
                                          )
                                    }
                                    backspaceRemovesValue={false}
                                    controlShouldRenderValue={true}
                                    value={appointmentPersonOptions
                                      ?.filter(
                                        (el) =>
                                          el?.UserType === item?.PayeeUserType
                                      )
                                      ?.find(
                                        (option) =>
                                          option?.value == item?.PayeeId
                                      )}
                                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                    placeholder={
                                      transactionid === 0
                                        ? "Please Select the Transaction Type First"
                                        : "Payee"
                                    }
                                    id="Payee"
                                    name="Payee"
                                    className="custom-search-select col-md-11 ml-2"
                                    isDisabled={
                                      item?.TransactionTypeID == 12 ||
                                      item?.TransactionTypeID == 11 ||
                                      item?.TransactionTypeID == 13 ||
                                      item?.TransactionTypeID == 7 ||
                                      item?.TransactionTypeID == 3 ||
                                      item?.TransactionTypeID == 8 ||
                                      item?.TransactionTypeID == 9
                                        ? true
                                        : false
                                    }
                                  />
                                )}
                                {/* {item?.PayeeUserType + " : " + item?.PayeeId} : 45 {item?.showAll} */}
                                {/* <td style={{ padding: "1px" textAlign: "-webkit-center",}}> */}
                                {item.IsSplit == 1 ? (
                                  <>
                                    <button
                                      className="btn btn-sm btn-outline-primary btn-custom-padding col-md-11  mt-2 ml-2"
                                      data-toggle="tooltip"
                                      data-placement="bottom"
                                      data-bs-toggle="modal"
                                      data-bs-target="#SplittingConfirmationModal"
                                      onClick={() =>
                                        Spilliting(item.SplitRecords)
                                      }
                                      // style={{ width: "100%" }}
                                    >
                                      -Split-
                                    </button>
                                  </>
                                ) : (
                                  <Select
                                    // onChange={(e, i) => {
                                    //   setAccountId(e?.value);
                                    //   handleQuickBookChange(e, i);
                                    // }}
                                    onChange={(event) =>
                                      handleInputChange(
                                        event,
                                        index,
                                        "AccountID"
                                      )
                                    }
                                    value={accountTypeDropdownOption.find(
                                      (option) =>
                                        option?.value == item?.AccountID
                                    )}
                                    options={accountTypeDropdownOption}
                                    backspaceRemovesValue={false}
                                    controlShouldRenderValue={true}
                                    hideSelectedOptions={true}
                                    isClearable={true}
                                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                    id="AccountId"
                                    name="AccountId"
                                    // isDisabled={item?.IsDefaultBalance == 1}
                                    isDisabled={
                                      item?.TransactionTypeID == 3 ||
                                      item?.TransactionTypeID == 8 ||
                                      item?.TransactionTypeID == 9 ||
                                      item?.IsDefaultBalance == 1
                                        ? true
                                        : false
                                    }
                                    className="custom-search-select mt-3 col-md-11 ml-2"
                                  />
                                )}

                                <input
                                  className="form-control form-control-sm mt-3 col-md-12 mb-3"
                                  type="text"
                                  style={inputStyles}
                                  placeholder="Memo"
                                  onChange={(event) =>
                                    handleInputChange(event, index, "Memo")
                                  }
                                  value={item?.Memo}
                                  // disabled={item?.IsDefaultBalance === 1}
                                  disabled={
                                    item?.TransactionTypeID == 3 ||
                                    item?.TransactionTypeID == 8 ||
                                    item?.TransactionTypeID == 9 ||
                                    item?.IsDefaultBalance == 1
                                      ? true
                                      : false
                                  }
                                />

                                {/* <span className="ml-2">{item?.AmountPaid}</span>
                                <br></br>
                                <span className="ml-2">{item?.CreditNote}</span> */}
                                {/* </td> */}
                              </td>
                              {/* <td style={{ padding: "1px" textAlign: "-webkit-center",}}>

                                  {item.IsSplit == 1 ?
                                    <>
                                      <button className="btn btn-sm btn-outline-primary btn-custom-padding" data-toggle="tooltip" data-placement="bottom"
                                        data-bs-toggle="modal"
                                        data-bs-target="#SplittingConfirmationModal"
                                        onClick={() => Spilliting(item.SplitRecords)}
                                        style={{ "width": "100%" }}>

                                        -Split-
                                      </button>
                                    </>
                                    : <Select
                                      // onChange={(e, i) => {
                                      //   setAccountId(e?.value);
                                      //   handleQuickBookChange(e, i);
                                      // }}
                                      onChange={(event) => handleInputChange(event, index, "AccountID")}
                                      value={accountTypeDropdownOption.find(
                                        (option) => option?.value == item?.AccountID
                                      )}
                                      options={accountTypeDropdownOption}
                                      backspaceRemovesValue={false}
                                      controlShouldRenderValue={true}
                                      hideSelectedOptions={true}
                                      isClearable={true}
                                      styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                                      id="AccountId"
                                      name="AccountId"
                                      isDisabled={item?.IsDefaultBalance == 1}
                                    />

                                  }
                                </td> */}
                              {/* <td
                            style={{
                              
                              verticalAlign: "-webkit-baseline-middle",
                              width: "35%",
                              fontSize: "12px",
                            }}
                          >
                            
                          </td> */}
                              <td
                                style={{
                                  // padding: "1px",
                                  textAlign: "-webkit-center",
                                  verticalAlign: "-webkit-baseline-middle",
                                  width: "27%",
                                  fontSize: "12px",
                                }}
                              >
                                <>
                                  <input
                                    className="form-control form-control-sm "
                                    type="number"
                                    style={{ width: "99px", fontSize: "12px" }}
                                    // style={inputStyles}
                                    value={item?.Payment}
                                    onChange={(event) =>
                                      handleInputChange(event, index, "Payment")
                                    }
                                    disabled={
                                      item?.TransactionTypeID == 12 ||
                                      item?.TransactionTypeID == 7 ||
                                      item?.TransactionTypeID == 11 ||
                                      item?.TransactionTypeID == 14 ||
                                      (item?.TransactionTypeID == 6 &&
                                        item?.IsSplit == 1) ||
                                      (item?.TransactionTypeID == 13 &&
                                        item?.Payment == 0) ||
                                      item?.IsDefaultBalance == 1 ||
                                      item?.TransactionTypeID == 3 ||
                                      item?.TransactionTypeID == 8 ||
                                      item?.TransactionTypeID == 9
                                        ? true
                                        : false
                                    }
                                  />

                                  <br></br>
                                  <span
                                    className="ml-2"
                                    style={{ textAlign: "left" }}
                                  >
                                    <strong>{item?.AmountPaid}</strong>
                                  </span>
                                  <br></br>
                                  {item?.CreditNote > 0 && (
                                    <span
                                      className="ml-4"
                                      style={{ textAlign: "left" }}
                                    >
                                      <strong>
                                        Credit Applied:{" "}
                                        {parseInt(item?.CreditNote).toFixed(2)}
                                      </strong>
                                    </span>
                                  )}
                                </>
                              </td>

                              <td
                                style={{
                                  padding: "1px",
                                  textAlign: "-webkit-center",
                                  verticalAlign: "-webkit-baseline-middle",
                                }}
                              >
                                <input
                                  className="form-control form-control-sm"
                                  type="number"
                                  style={{ width: "99px", fontSize: "12px" }}
                                  // style={inputStyles}
                                  value={item?.Deposit}
                                  onChange={(event) =>
                                    handleInputChange(event, index, "Deposit")
                                  }
                                  disabled={
                                    (item?.TransactionTypeID == 12 &&
                                      item?.Deposit == 0 &&
                                      item?.IsSplit == 1) ||
                                    item?.TransactionTypeID == 14 ||
                                    item?.TransactionTypeID == 11 ||
                                    item?.TransactionTypeID == 6 ||
                                    item?.TransactionTypeID == 7 ||
                                    item?.TransactionTypeID == 13 ||
                                    item?.IsDefaultBalance == 1 ||
                                    item?.TransactionTypeID == 3 ||
                                    item?.TransactionTypeID == 8 ||
                                    item?.TransactionTypeID == 9
                                      ? true
                                      : false
                                  }
                                />
                                <td>
                                  {" "}
                                  {accountId == 1 || accountId == 5
                                    ? `${
                                        item?.DueDate
                                          ? moment(item?.DueDate).format(
                                              "YYYY-MM-DD"
                                            )
                                          : ""
                                      }`
                                    : ""}
                                </td>
                                {item?.TransactionTypeID == 3 ||
                                item?.TransactionTypeID == 8 ||
                                item?.TransactionTypeID == 9 ||
                                item?.Type === "Opening Balance" ||
                                accountId == 1 ||
                                accountId == 5 ||
                                item?.Deleted === 1 ? (
                                  ""
                                ) : (
                                  <button
                                    type="button"
                                    class="btn btn-primary btn-sm mr-1 "
                                    onClick={() =>
                                      handleSubmit("edit", index, item.IsSplit)
                                    }
                                  >
                                    Save
                                  </button>
                                )}
                              </td>
                              <td
                                style={{
                                  padding: "1px",
                                  textAlign: "-webkit-center",
                                  verticalAlign: "-webkit-baseline-middle",
                                  width: "27%",
                                  // border: "1px solid red",
                                  fontSize: "12px",
                                }}
                              >
                                <input
                                  value={rowsData[index].cr}
                                  className="form-control form-control-sm"
                                  // style={inputStyles}
                                  style={{
                                    fontSize: "12px",
                                    width: "45px",
                                    cursor: "pointer",
                                  }}
                                  //placeholder="C/R"
                                  type="text"
                                  onClick={() => handleRowInputClick(index)}
                                  // onChange={(event) => handleInputChange(event, index, "cr")}
                                  // disabled={item?.IsDefaultBalance === 1}
                                  disabled={
                                    item?.TransactionTypeID == 3 ||
                                    item?.TransactionTypeID == 8 ||
                                    item?.TransactionTypeID == 9 ||
                                    item?.IsDefaultBalance == 1
                                      ? true
                                      : false
                                  }
                                  readOnly
                                />

                                <td></td>
                                {/* {item?.TransactionTypeID == 3 ||
                                item?.TransactionTypeID == 8 ||
                                item?.TransactionTypeID == 9 ? (
                                  ""
                                ) : ( */}
                                {item?.Type !== "Opening Balance" &&
                                  item?.Deleted !== 1 && (
                                    <button
                                      type="button"
                                      class="btn btn-secondary btn-sm mb-1 mr-1"
                                      onClick={() =>
                                        handleEdit(
                                          item?.TransactionTypeID,
                                          item?.ID,
                                          item?.Type,
                                          item?.RecSaleID
                                        )
                                      }
                                    >
                                      Edit
                                    </button>
                                  )}
                              </td>
                              <td
                                style={{
                                  padding: "1px",
                                  textAlign: "-webkit-center",
                                  verticalAlign: "-webkit-baseline-middle",
                                  width: "27%",
                                  // border: "1px solid red",
                                  fontSize: "12px",
                                }}
                              >
                                {item?.Balance < 0 ? (
                                  <p className="mb-2" style={{ color: "red" }}>
                                    {item.Balance}
                                  </p>
                                ) : selectTransaction === 1 ||
                                  selectTransaction === undefined ? (
                                  <p className="mb-2">{item?.Balance}</p>
                                ) : index === 0 ? (
                                  <>
                                    <p>(Only displayed with</p>
                                    <p>date/reconcile </p>
                                    <p>status sort)</p>
                                  </>
                                ) : (
                                  "n/a"
                                )}
                                <td></td>
                                <td></td>
                                {item?.TransactionTypeID == 3 ||
                                item?.TransactionTypeID == 8 ||
                                item?.TransactionTypeID == 9 ||
                                accountId == 1 ||
                                accountId == 5 ||
                                item?.Deleted === 1 ? (
                                  ""
                                ) : item?.IsDefaultBalance != 1 ? (
                                  <div class="row">
                                    <div class="col-md-12">
                                      {
                                        <>
                                          {item.IsDefaultBalance == 0 && (
                                            <>
                                              <button
                                                type="button"
                                                class="btn btn-secondary btn-sm  mt-1"
                                                onClick={() =>
                                                  handleDeleteClick(item, index)
                                                }
                                              >
                                                Delete
                                              </button>
                                            </>
                                          )}
                                        </>
                                      }
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                <div
                                  className={`modal ${
                                    stateModal.visible === index
                                      ? "d-block"
                                      : ""
                                  }`}
                                  tabIndex="-1"
                                  style={{ background: "rgba(0,0,0,0.2)" }}
                                >
                                  <div className="modal-dialog modal-sm modal-dialog-centered">
                                    <div className="modal-content">
                                      <div className="modal-header">
                                        <h5 className="title-model">
                                          Confirmation
                                        </h5>
                                        <button
                                          type="button"
                                          className="btn-close"
                                          data-bs-dismiss="modal"
                                          aria-label="Close"
                                          onClick={handleClose}
                                        >
                                          <span aria-hidden="true">×</span>
                                        </button>
                                      </div>
                                      <div className="modal-body">
                                        <div className="row">
                                          <div className="col-lg-12">
                                            <p className="mb-2">
                                              Are you sure you want to delete
                                              this row?
                                            </p>
                                            {false && (
                                              <>
                                                <p className=" text-danger">
                                                  Note: Credit delete need to
                                                  deleted manually
                                                </p>
                                                <p className=" text-danger">
                                                  from the QuickBook because it
                                                  won't SYNC.
                                                </p>
                                              </>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="modal-footer justify-content-center">
                                        <button
                                          type="button"
                                          className="btn btn-primary"
                                          onClick={() => handleConfirmDelete()}
                                        >
                                          Delete
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-secondary"
                                          onClick={handleCancelDelete}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </td>

                              {/* <td style={{ padding: "1px",textAlign: "-webkit-center",verticalAlign: "-webkit-baseline-middle"}}> */}
                              {/* <div class="row">
                                    <div class="col-md-12">
                                      {
                                        <>
                                          {
                                            item.IsDefaultBalance == 0 && (<button type="button" class="btn btn-outline-primary  btn-sm btn-custom-padding mr-1" onClick={() => handleSubmit("edit", index, item.IsSplit)}>
                                              <i class="fa fa-check" ></i>
                                            </button>)
                                          }
                                          {
                                            item.showDelete && item.IsDefaultBalance == 0 && (
                                              <button type="button" class="btn btn-outline-danger  btn-sm btn-custom-padding mr-1" onClick={() => handleDeleteClick(item, index)}>
                                                <i class="fa fa-trash"></i>
                                              </button>
                                            )
                                          }
                                        </>
                                      }
                                    </div>
                                  </div> */}
                              {/* Delete confirmation modal */}
                              {/* <div
                                    className={`modal ${stateModal.visible === index ? "d-block" : ""}`}
                                    tabIndex="-1"
                                    style={{ background: "rgba(0,0,0,0.2)" }}
                                  >
                                    <div className="modal-dialog modal-dialog-centered">
                                      <div className="modal-content">
                                        <div className="modal-header">
                                          <h5 className="modal-title">Confirmation</h5>
                                          <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            onClick={handleClose}
                                          >
                                            <span aria-hidden="true">×</span>
                                          </button>
                                        </div>
                                        <div className="modal-body">
                                          <div className="row">
                                            <div className="col-lg-12">
                                              <h6>Are you sure you want to delete this row?</h6>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="modal-footer justify-content-center">
                                          <button type="button" className="btn btn-primary" onClick={() => handleConfirmDelete()}>
                                            Delete
                                          </button>
                                          <button type="button" className="btn btn-secondary" onClick={handleCancelDelete}>
                                            Cancel
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div> */}
                              {/* </td> */}
                            </tr>
                          );
                        })}
                  </tbody>
                </table>
                <div>
                  <button
                    className="btn btn-sm btn-secondary me-2"
                    onClick={() => navigate(-1)}
                    style={{ marginTop: "20px" }}
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SplittingConfirmationModal  SplitData={splits}/>
    </>
  );
};

export default ViewRegister;
